import styles from './showMore.scss';
import cn from 'classnames';
import { IconArrow } from 'components/Shared/Icon/themes/BGH-RD3/iconArrow';
import { Button } from 'components/Button';

interface ShowMoreProps {
  href: string;
  title: string;
  appearance: 'primary' | 'secondary' | 'tertiary';
}

export const ShowMore = ({ title, href, appearance }: ShowMoreProps) => {
  return (
    <Button
      href={href}
      appearance="tertiary"
      border="thin"
      className={cn(styles.buttonLarge, {
        [styles.buttonMedium]: appearance === 'secondary',
        [styles.buttonSmall]: appearance === 'tertiary'
      })}
    >
      <p>{title}</p>
      <IconArrow thickness="thin" className={cn(styles.icon)} />
    </Button>
  );
};
